import { Reveal, Eyebrow } from "./Reveal";

const steps = [
  ["Escolha sua tiragem", "De uma pergunta à meia hora de conversa. Escreva suas dúvidas com calma."],
  ["Pague via Pix", "Um QR Code e um código copia e cola são gerados na hora, direto pelo Mercado Pago."],
  ["Confirmação automática", "Assim que o Pix cai, o site confirma sozinho — sem enviar comprovante."],
  ["Abra o WhatsApp", "Você é levado ao WhatsApp com seu pedido e suas perguntas já escritos."],
];

export const Steps = () => (
  <section id="como-funciona" data-testid="steps-section" className="relative mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-36">
    <div className="grid gap-14 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>Como funciona</Eyebrow>
        <h2 className="font-display mt-6 text-5xl leading-[0.95] tracking-tight text-[#F5F2EB] md:text-6xl">
          Quatro passos <em className="gold-text">até a sua carta.</em>
        </h2>
      </Reveal>
      <div className="lg:col-span-8">
        {steps.map(([t, d], i) => (
          <Reveal key={t} delay={i * 0.08}>
            <div data-testid={`step-${i + 1}`} className="group grid grid-cols-[auto_1fr] gap-6 border-t border-white/10 py-8 md:grid-cols-[120px_1fr_1.2fr] md:gap-10">
              <span className="font-display text-5xl italic text-[#CBA365]/70 transition-colors duration-500 group-hover:text-[var(--gold)]">0{i + 1}</span>
              <h3 className="font-display self-center text-2xl text-[#F5F2EB] md:text-3xl">{t}</h3>
              <p className="col-span-2 text-sm leading-relaxed text-white/70 md:col-span-1 md:self-center md:text-base">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
